/* Generated by scripts/build-css.ts. DO NOT EDIT. */

/**
 * The motion tokens zeroed under reduced motion, shared with core.css's
 * `@media (prefers-reduced-motion: reduce)` block. Native cannot evaluate that
 * query, so `AlouetteProvider` pushes this map through NativeWind's
 * `VariableContextProvider` when the OS setting is on.
 */
export const reducedMotionVariables = {
  "--default-transition-duration": 0,
  "--motion-duration-slide": 0,
  "--motion-duration-collapse": 0,
  "--motion-duration-disclose": 0,
  "--motion-duration-progress": 0,
  "--motion-duration-fade": 0,
  "--motion-duration-fast": 0,
  "--motion-duration-caret": 0,
  "--motion-duration-pulse": 0,
  "--animate-slide-in": "none",
  "--animate-slide-out": "none",
  "--animate-collapse-in": "none",
  "--animate-collapse-out": "none",
  "--animate-disclose-in": "none",
  "--animate-disclose-out": "none",
  "--animate-caret-blink": "none",
  "--animate-pulse": "none",
} as const;
